declare global {
  interface Window {
    ENV?: {
      REACT_APP_API_BASE_URL: string;
      REACT_APP_ENVIRONMENT: string;
      REACT_APP_UMAMI_WEBSITE_ID: string;
      REACT_APP_BANNER_CUP_KEYS: string;
    };
  }
}

export const env = {
  apiBaseUrl: window.ENV?.REACT_APP_API_BASE_URL ?? process.env.REACT_APP_API_BASE_URL ?? '',
  environment: window.ENV?.REACT_APP_ENVIRONMENT ?? process.env.REACT_APP_ENVIRONMENT ?? '',
  umamiWebsiteId: window.ENV?.REACT_APP_UMAMI_WEBSITE_ID ?? process.env.REACT_APP_UMAMI_WEBSITE_ID ?? '',
  bannerCupKeys: window.ENV?.REACT_APP_BANNER_CUP_KEYS ?? process.env.REACT_APP_BANNER_CUP_KEYS ?? '',
};
